<template>
  <div id="unauthenticated-wrapper">
    <loading v-if="$store.state.app.loading" />
    <v-main>
      <v-container fluid>
        <router-view :key="$route.path" />
      </v-container>
    </v-main>
  </div>
</template>

<script>
  import Loading from '../../components/Loading/Index'
  export default {
    name: 'DefaultView',
    components: { Loading },
  }
</script>
